import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { TreasureService } from '@app/_v2/games/treasure/services/treasure.service';
import GameInterfaces from '@app/_v2/games/treasure/interfaces';
import { Subscription } from 'rxjs/Subscription';
import { Logger } from '@app/core';
import { SmartAlertService } from '../../../../core/smart-alert.service';

const logger = new Logger('@treasure-hunt:treasure-item.component.ts');

enum Background {
  Normal = 0,
  Win = 1,
  Lose = 2,
  Key = 3,
}

@Component({
  selector: 'app-treasure-reply-item',
  templateUrl: './treasure-reply-item.component.html',
  styleUrls: ['./treasure-reply-item.component.scss'],
})
export class TreasureReplyItemComponent implements OnInit, OnDestroy, OnChanges {
  @Input('openCase') openCase: number = -1;
  @Input('row') row: number = 0;

  readonly rows: number = 10;
  readonly itemsPerRow: number = 3;

  data: GameInterfaces.OpenResult;

  bg = Background;

  // Animation related data
  opened: boolean = false;
  openedParts: boolean = false;
  background: number = Background.Normal;

  _actionsSubscriber: Subscription;
  _winningSubscriber: Subscription;

  constructor(public smartAlert: SmartAlertService) {}

  ngOnInit() {}

  ngOnDestroy() {
    if (this._actionsSubscriber) {
      this._actionsSubscriber.unsubscribe();
    }
    if (this._winningSubscriber) {
      this._winningSubscriber.unsubscribe();
    }
  }

  ngOnChanges() {
    this.imitateOpening();
  }

  private imitateOpening() {
    if (this.openCase !== -1) {
      this.opened = false;
      this.openedParts = false;
      this.background = Background.Normal;

      switch (this.openCase) {
        case 0: {
          this.startOpeningAnimation('win');
          break;
        }
        case 1: {
          this.startOpeningAnimation('key');
          break;
        }
        case 2: {
          this.startOpeningAnimation('lose');
          break;
        }
      }
    }
  }

  private async startOpeningAnimation(result: string): Promise<void> {
    this.opened = true; // Prepare chest to be opened
    await this.delay(550); // Breakpoint 1
    this.openedParts = true; // Disable normal chest & show parts of chest
    await this.delay(100);
    switch (result) {
      case 'win': {
        this.background = Background.Win;
        break;
      }
      case 'lose': {
        this.background = Background.Lose;
        await this.delay(500);
        break;
      }
      case 'key': {
        this.background = Background.Key;
        await this.delay(500);
        break;
      }
    }
    await this.delay(1500);
  }

  private delay(time: number): Promise<boolean> {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(true);
      }, time);
    });
  }

  public get isLastRow(): number {
    return this.rows - 1;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/components/reply/reply-treasure/treasure-reply-item.component.ts